<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: "app",
  data() {
    return {
    }
  },
  watch: {
    '$store.state.maintenance.running' (newVal, oldVal) {
      if(oldVal == true && newVal == false) {
        location.reload();
      }
    }
  },
  methods: {
    desktop_notification: function( cb ) {
      if (("Notification" in window)) {
        if (Notification.permission === "granted") {
          cb();
        } else if (Notification.permission !== 'denied') {
          Notification.requestPermission(function (permission) {
            if (permission === "granted") {
              cb();
            }
          });
        }
      }
    },
    show_msg: function(type, msg, desktop) {
      this.$notify({
        message: msg,
        type: type
      })
      if (desktop === true) {
        this.desktop_notification(function() {
          var n = new Notification(type, {
            body: msg
          });
          setTimeout(n.close.bind(n), 15000);
        });
      }
    }
  },
  created: function() {
    var self = this;
    Vue.prototype.$message = {
      error: function(msg, desktop) {
        self.show_msg("danger", msg, desktop);
      },
      warning: function(msg, desktop) {
        self.show_msg("warning", msg, desktop);
      },
      success: function(msg, desktop) {
        self.show_msg("success", msg, desktop);
      },
      info: function(msg, desktop) {
        self.show_msg("info", msg, desktop);
      }
    };
  }
}
</script>

<style src="../public/css/notifyjs.css"></style>
<style>
.CodeMirror, .CodeMirror-scroll {
	min-height: 150px !important;
}
</style>
